<div
  cdkAccordionItem
  #accordionItem="cdkAccordionItem"
  cdkDrag
  [cdkDragData]="data()"
  [cdkDragDisabled]="!draggable()"
  (opened)="selectionChange.emit()"
>
  <div
    class="group grid grid-cols-[auto_minmax(0,1fr)] bg-white relative before:absolute before:inset-y-0 before:start-0 before:w-0.75 before:transition-colors [.active]:before:bg-primary-700 hover:not-[.active]:before:bg-gray-300"
    [class]="{
      active: selected(),
    }"
  >
    <div
      class="col-span-full grid grid-cols-subgrid p-4 pr-2.5 cursor-pointer select-none"
      (click)="accordionItem.toggle()"
      role="presentation"
    >
      @if (draggable()) {
        <button
          mat-icon-button
          class="inline-flex! size-8! p-1! -ml-2 mr-2"
          cdkDragHandle
          [disabled]="accordionItem.expanded"
          (click)="$event.stopPropagation()"
        >
          <mat-icon>drag_handle</mat-icon>
        </button>
      }

      <div class="flex col-start-2">
        <div
          class="flex flex-auto gap-1 text-sm min-w-0"
          role="presentation"
          [class]="{
            'my-auto': data().type === 'text',
            'items-center': data().type === 'image',
          }"
        >
          @if (index()) {
            <span>{{ index() }}.</span>
          }

          @if (data().type === 'text') {
            <span
              class="break-words min-w-0 flex-auto"
              [innerHTML]="$any(data().value) | highlightVariables"
            ></span>
          }

          @if (data().type === 'image') {
            @let imageAnswer = asImageAnswer(data());
            <div class="flex items-center gap-2 flex-1 min-w-0">
              <app-avatar
                class="block size-8 rounded-full overflow-hidden relative shrink-0"
                [src]="getFileUrl(imageAnswer.value.fileId)"
                [alt]="imageAnswer.value.label"
              >
                <div
                  class="text-xl bg-gray-200 text-gray-400 absolute inset-0 flex items-center justify-center opacity-100 transition-opacity"
                >
                  <mat-icon inline>image</mat-icon>
                </div>
              </app-avatar>
              <span class="truncate" [matTooltip]="imageAnswer.value.label">{{
                imageAnswer.value.label
              }}</span>

              @if (totalAnswers() === 1) {
                <mat-button-toggle-group
                  class="fullscreen-toggle ml-auto shrink-0"
                  hideSingleSelectionIndicator
                  [value]="imageAnswer.fullScreen ? 'fullscreen' : 'normal'"
                  [disabled]="!draggable()"
                  (click)="$event.stopPropagation()"
                  (change)="onFullScreenToggle($event.value === 'fullscreen')"
                >
                  <mat-button-toggle value="normal" matTooltip="Normaal">
                    <mat-icon>photo_size_select_large</mat-icon>
                  </mat-button-toggle>
                  <mat-button-toggle value="fullscreen" matTooltip="Beeldvullend">
                    <mat-icon>fullscreen</mat-icon>
                  </mat-button-toggle>
                </mat-button-toggle-group>
              }
            </div>
          }
        </div>

        <div class="flex pointer-events-none">
          <span class="inline-flex size-8 p-1 items-center justify-center">
            <mat-icon [class]="accordionItem.expanded ? 'rotate-180' : 'rotate-0'"
              >keyboard_arrow_down</mat-icon
            >
          </span>
        </div>
      </div>
    </div>

    <div
      class="col-span-full grid grid-cols-subgrid px-4 pb-4 pr-2.5"
      [class]="accordionItem.expanded ? 'block' : 'hidden'"
    >
      <div class="col-start-2 min-h-12">
        <app-action-list
          [actions]="data().children"
          [dropListId]="data()._id"
          [disableControls]="!draggable()"
          [clientId]="clientId()"
        />
      </div>
    </div>
  </div>
</div>
